import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-10 relative z-20">
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-2 md:gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-2 p-3 md:p-4 bg-background-100/80 backdrop-blur-sm border border-background-200/40 rounded-xl hover:border-primary-500/40 hover:bg-background-100 transition-all duration-200 group cursor-pointer"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
              <i className={`${cat.icon} text-lg md:text-xl text-primary-500`}></i>
            </div>
            <span className="text-xs md:text-sm text-foreground-300 group-hover:text-foreground-100 whitespace-nowrap transition-colors">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}